import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_BASE_URL}/api01`,
  prepareHeaders: (headers) => {
    const businessId = localStorage.getItem('business');
    if (businessId) {
      headers.set("business", businessId);
    }
    headers.set('Content-Type', 'application/json');

    return headers;
  },
});
